export const RECOVER_USER_REQUEST = "RECOVER_USER_REQUEST";
export const RECOVER_USER_REQUEST_SUCCESS = "RECOVER_USER_REQUEST_SUCCESS";
export const RECOVER_USER_REQUEST_ERROR = "RECOVER_USER_REQUEST_ERROR";
